/*
 * File: /src/helpers/is-shopify-embedded.js
 * Project: air-fields-shopify-frontend
 * -
 * File Created: Monday, 21st October 2025
 * -
 * @description: Helper to detect if app is running embedded in Shopify Admin
 * Replaces @shopify/app-bridge-utils isShopifyEmbedded function
 */

/**
 * Check if the app is running inside Shopify Admin (embedded in an iframe)
 * @returns {boolean} True if embedded, false otherwise
 */
export const isShopifyEmbedded = () => {
    // Check if we're in a browser environment
    if (typeof window === 'undefined') {
        return false
    }

    // App is embedded if it's running in an iframe (window.self !== window.top)
    try {
        return window.self !== window.top
    } catch (e) {
        // If we get a security error accessing window.top, we're likely in an iframe
        return true
    }
}

/**
 * Check whether the page was opened by Shopify, even without an iframe.
 * Shopify Mobile loads embedded apps in a top-level WebView, so
 * isShopifyEmbedded() is false there. Use this together with it.
 * @param {Object} query - The route query (`to.query`)
 * @returns {boolean} True if any Shopify context signal is present
 */
export const isShopifyContext = query => {
    const q = query || {}

    if (q.embedded === '1' || q.host) {
        return true
    }

    if (typeof window === 'undefined') {
        return false
    }

    const environment = window.shopify && window.shopify.environment
    return !!(environment && (environment.embedded || environment.mobile))
}

export default isShopifyEmbedded



// WEBPACK FOOTER //
// ./src/helpers/is-shopify-embedded.js